import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { OktaAuthService } from "@okta/okta-angular";
import { SpinnerService } from "../services/spinner.service";
import { NotificationService } from "../services/notification.service";
import { AuthService } from "../services/auth.service";
import { HttpErrorResponse } from "@angular/common/http";
import { SearchService } from "../services/search.service";
import { UserActionService } from "../services/user-action.service";
import { DialogService } from '../services/dialog.service';

@Component({
  selector: "app-default-redirect",
  templateUrl: "./default-redirect.component.html",
  styleUrls: ["./default-redirect.component.css"],
})
export class DefaultRedirectComponent implements OnInit {
  constructor(
    private userService: UserService,
    private router: Router,
    private oktaAuthService: OktaAuthService,
    private spinnerService: SpinnerService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private searchService: SearchService,
    private userActionService: UserActionService,
    private dialogService: DialogService
  ) {
    this.getUser();
  }

  ngOnInit(): void {
    /*
    console.log("Default Redirect Component Initialized");
    if (!this.userService.alert) {
      this.userService.alert = true;
      var title = "Attention Azkaban Users";
      //var message = "WBD Pass fix has been deployed and we can report  that <b>all functions are working as intended.</b> At this time we can move forward with WBD Pass.  If you see any issues with the system, please use the <b>“Report a Problem”</b> function on the bottom left of the screen.  If needed, contact us at <b>818-954-3588</b> or email <b>Securitydriveonrequests@wbd.com</b> with your pass details. We’re happy to process them for you.  Thank you for your patience and cooperation."
      var message = "Azkaban will be undergoing scheduled maintenance on <b>July 18, 2026, from 8:00 PM to 1:00 AM PST.</b> Service interruptions and temporary outages may occur during this time. Please plan accordingly. Thank you for your understanding."
      this.dialogService.openAlertDialogDialog(
        title,
        message,
        "500px",
        "auto",
        //"warning"
      );
    }
      */
  }

  private async getUser() {
    this.spinnerService.setIsLoading(true);

    const res = await this.oktaAuthService.getUser();
    this.userService.firstName = res.given_name;
    this.userService.middleName = null;
    this.userService.lastName = res.family_name;
    this.userService.userEmail = res.email;

    this.userService.setRegisteredUserGroups(res.groups);
    this.userService.setOktaUserInfo(res);

    if (res.groups.length > 0) {
      this.userService
        .userLoginAPI()
        .then(() =>
          this.userService
            .getUserAPI(this.userService.userID)
            .catch(() => {})
        )
        .then(() => {
          this.spinnerService.setIsLoading(false);

          localStorage["isUserRegistered"] = true;
          this.searchService.selectedApplicationID = this.userService.userApplications[0].ApplicationID;

          // log the default selected user application
          const userApplications = this.userService.userApplications;

          const selectedApp = this.userService.userApplications[0].ApplicationID;
          const newAppName = this.userService.userApplications[0].Name;
          const route = this.userService.userApplications[0].Route

          // log it into user actions
          this.userActionService.recordUserActionAPI(
            "Application Change",
            `Changed From: ${undefined} (${undefined}) To: ${newAppName} (${selectedApp})`
          );

          // route user to application
          this.router.navigate([route]);
        })
        .catch((err: HttpErrorResponse) => {
          this.spinnerService.setIsLoading(false);
          this.notificationService.failure(err.message);
          this.authService.logout();
        });
    } else {
      this.notificationService.failure(
        "You are not assigned to any of the required AD Groups."
      );
      this.authService.logout();
    }
  }
}
